/*
 * SIWS CUSTOM 2026-06-12 — Inventory-Ceiling Clamp Module
 *
 * Third clamp module in the SIWS library:
 *   floor   — beverage dispenser min, gift card min, duck camo cart min
 *   step    — gift card 50-unit step, screwdriver 50-unit step
 *   ceiling — THIS MODULE: per-variant inventory hard cap, cart-aware
 *
 * First consumer: Golf Balls PDP + cart row (Cornwell golf products,
 * tracked inventory, continue-selling off). Reusable for any future
 * inventory-tracked product where the dealer should never be able to
 * overshoot stock.
 *
 * Two public binders, both expect data attrs on a root element:
 *   SiwsInventoryClamp.bindPdp(rootEl)
 *   SiwsInventoryClamp.bindCartRow(rowEl)
 *
 * PDP data attrs (read off rootEl):
 *   data-siws-clamp="ceiling"
 *   data-section-id            — owning section id (for #Quantity-{id})
 *   data-variant-id            — int, current variant id
 *   data-inventory             — int, variant.inventory_quantity at render
 *   data-inventory-managed     — "true" | "false" (shopify-managed AND policy!='continue')
 *   data-cart-qty              — int, item_count_for_variant at render
 *
 * Cart row data attrs (read off <tr class="cart-item">):
 *   data-inventory             — int
 *   data-inventory-managed     — "true" | "false"
 *
 * Module is idempotent — guard flag prevents double-binding when Dawn
 * re-renders the cart section.
 */
(function () {
  if (window.__siwsInventoryClampInstalled) return;
  window.__siwsInventoryClampInstalled = true;

  /* ─── PDP ──────────────────────────────────────────────────────────── */

  function bindPdp(rootEl) {
    if (!rootEl || rootEl.dataset.siwsClampBound === 'true') return;

    var managed = rootEl.getAttribute('data-inventory-managed') === 'true';
    var inventory = parseInt(rootEl.getAttribute('data-inventory'), 10);
    if (!managed || isNaN(inventory)) return;

    var sectionId = rootEl.getAttribute('data-section-id');
    var variantId = parseInt(rootEl.getAttribute('data-variant-id'), 10);
    var cartQty   = parseInt(rootEl.getAttribute('data-cart-qty'), 10) || 0;

    var qtyInput   = document.getElementById('Quantity-' + sectionId);
    var atcBtn     = document.getElementById('ProductSubmitButton-' + sectionId);
    var remainingEl = rootEl.querySelector('[data-siws-remaining]');
    if (!qtyInput || !atcBtn) return;

    var quantityInputWrapper = qtyInput.closest('quantity-input') || qtyInput.parentElement;
    var plusBtn  = quantityInputWrapper.querySelector('.quantity__button[name="plus"]');
    var minusBtn = quantityInputWrapper.querySelector('.quantity__button[name="minus"]');

    // Capture original ATC label once so we can restore it if cart shrinks.
    if (!atcBtn.dataset.siwsClampOriginalLabel) {
      var labelSpan = atcBtn.querySelector('span');
      if (labelSpan) atcBtn.dataset.siwsClampOriginalLabel = labelSpan.textContent.trim();
    }

    function getRemaining() { return Math.max(0, inventory - cartQty); }

    function render() {
      var remaining = getRemaining();
      var typedQty  = parseInt(qtyInput.value, 10) || 0;

      if (remaining <= 0) {
        // MAXED — cart already holds entire stock.
        if (remainingEl) {
          remainingEl.textContent = 'Maximum Quantity In Cart';
          remainingEl.classList.add('is-maxed');
        }
        atcBtn.disabled = true;
        atcBtn.dataset.siwsClampDisabled = 'true';
        var spanMax = atcBtn.querySelector('span');
        if (spanMax) spanMax.textContent = 'Maximum Quantity In Cart';
        if (plusBtn)  plusBtn.disabled = true;
        if (minusBtn) minusBtn.disabled = true;
        qtyInput.value = 0;
        qtyInput.setAttribute('max', '0');
        return;
      }

      // Available — paint live remaining that burns down with the stepper:
      // inventory − cartQty − typedQty, floored at 0. Repaints on every
      // input keystroke and +/− click via the listeners below. Input MAX
      // (set further down) stays at inventory − cartQty — the input is the
      // hard ceiling; the indicator just visualizes what's left after the
      // pending add. Sanity: stock 48 / cart 4 / input 2 → "42 Of 48".
      if (remainingEl) {
        var pending = Math.max(0, remaining - typedQty);
        remainingEl.textContent = pending + ' Of ' + inventory + ' Remaining';
        remainingEl.classList.remove('is-maxed');
      }

      // Restore ATC if we previously disabled it.
      if (atcBtn.dataset.siwsClampDisabled === 'true') {
        atcBtn.disabled = false;
        atcBtn.dataset.siwsClampDisabled = '';
        var spanRestore = atcBtn.querySelector('span');
        var original = atcBtn.dataset.siwsClampOriginalLabel;
        if (spanRestore && original) spanRestore.textContent = original;
      }
      qtyInput.setAttribute('max', String(remaining));
      if (plusBtn)  plusBtn.disabled  = (typedQty >= remaining);
      if (minusBtn) minusBtn.disabled = (typedQty <= 1);
    }

    function snapToMax() {
      var remaining = getRemaining();
      var typed = parseInt(qtyInput.value, 10) || 0;
      if (typed > remaining) {
        qtyInput.value = remaining;
        showPdpNotice('Only ' + remaining + ' Available');
      }
    }

    function showPdpNotice(msg) {
      var noticeId = 'siws-clamp-notice-' + sectionId;
      var el = document.getElementById(noticeId);
      if (!el) {
        el = document.createElement('div');
        el.id = noticeId;
        el.style.cssText =
          'background:#fffbeb;border:1px solid #f59e0b;border-radius:6px;' +
          'padding:0.8rem 1.2rem;font-size:1.3rem;color:#92400e;margin:0.8rem 0 0;';
        rootEl.appendChild(el);
      }
      el.textContent = '⚠️ ' + msg;
      clearTimeout(el._siwsClampTimer);
      el._siwsClampTimer = setTimeout(function () { if (el) el.textContent = ''; }, 4000);
    }

    qtyInput.addEventListener('input',  function () { snapToMax(); render(); });
    // Belt-and-braces: blur/enter (change) re-verifies cart truth in addition
    // to clamping — defends against missed cartUpdate events. Not on 'input'
    // (would spam /cart.js on every keystroke).
    qtyInput.addEventListener('change', function () { snapToMax(); render(); resync(); });
    if (plusBtn)  plusBtn.addEventListener('click',  function () { setTimeout(function () { snapToMax(); render(); }, 0); });
    if (minusBtn) minusBtn.addEventListener('click', function () { setTimeout(render, 0); });

    // Belt-and-braces: even if the pubsub subscription misses a cartUpdate
    // (or Dawn's product-form.js POST handler races us), force a resync
    // ~600ms after the dealer clicks ATC so the indicator catches up.
    atcBtn.addEventListener('click', function () { setTimeout(resync, 600); });

    // SIWS CUSTOM 2026-06-12 single counting code path — used by initial
    // truth-fetch AND by every PUB_SUB_EVENTS.cartUpdate handler. filter+
    // reduce (not find) so the count is correct even if a variant ever
    // splits across multiple cart lines (line-item-property variations).
    function fetchCartQty() {
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        return (cart.items || [])
          .filter(function (i) { return i.variant_id === variantId; })
          .reduce(function (s, i) { return s + i.quantity; }, 0);
      });
    }

    // Resync cart qty on every cartUpdate event (fixes stale-value-after-ATC).
    // SIWS CUSTOM 2026-06-12 — also write dataset.cartQty so the DOM attr
    // reflects live state; previously the attr was frozen at server-render
    // time (Chrome trace showed it stuck at "9" while cart truth was higher).
    function resync() {
      fetchCartQty().then(function (qty) {
        cartQty = qty;
        rootEl.dataset.cartQty = String(qty);
        var remaining = getRemaining();
        var typed = parseInt(qtyInput.value, 10) || 0;
        if (typed > remaining) qtyInput.value = Math.max(0, remaining);
        render();
      }).catch(function () { /* graceful degrade */ });
    }

    // SIWS CUSTOM 2026-06-12 — Dawn's pubsub.js exports `subscribe` as a function
    // declaration (attaches to window) but assets/constants.js declares
    // `const PUB_SUB_EVENTS` lexically — const is NOT a window property in
    // classic scripts. The previous `window.PUB_SUB_EVENTS &&` guard always
    // short-circuited, leaving resync unsubscribed. The first PDP add only
    // appeared to work because Dawn section re-renders re-ran bindPdp.
    // Check the lexical binding via `typeof`, fall back to window for theme
    // variants that do attach it.
    var events = (typeof PUB_SUB_EVENTS !== 'undefined') ? PUB_SUB_EVENTS
      : (window.PUB_SUB_EVENTS || null);
    if (typeof subscribe === 'function' && events && events.cartUpdate) {
      subscribe(events.cartUpdate, resync);
    } else {
      // Fallback for theme variants where pubsub isn't reachable — poll
      // /cart.js every 5s only while the PDP tab is visible (no background
      // hammering). Uses the existing fetchCartQty path via resync().
      setInterval(function () {
        if (document.visibilityState === 'visible') resync();
      }, 5000);
    }

    rootEl.dataset.siwsClampBound = 'true';
    // SIWS CUSTOM 2026-06-12 — first paint from the dataset estimate
    // (item_count_for_variant at render time) so dealers see a number
    // immediately, then resync() repaints with the /cart.js truth. The
    // dataset value cannot be trusted alone — section caching can serve
    // a stale render after /cart/add.js mutates the cart.
    render();
    resync();
  }

  /* ─── CART ROW ─────────────────────────────────────────────────────── */

  function bindCartRow(rowEl) {
    if (!rowEl) return;
    var managed = rowEl.getAttribute('data-inventory-managed') === 'true';
    var inventory = parseInt(rowEl.getAttribute('data-inventory'), 10);
    if (!managed || isNaN(inventory)) return;

    var qtyInput = rowEl.querySelector('.quantity__input');
    if (!qtyInput) return;

    qtyInput.setAttribute('max', String(inventory));
    var plusBtn = rowEl.querySelector('.quantity__button[name="plus"]');
    var cur = parseInt(qtyInput.value, 10) || 0;
    if (plusBtn) plusBtn.disabled = (cur >= inventory);

    if (qtyInput.dataset.siwsClampWired === 'true') return;

    qtyInput.addEventListener('change', function () {
      var typed = parseInt(qtyInput.value, 10) || 0;
      if (typed > inventory) {
        // Defensive desync guard: never let the rejected typed value live
        // in the DOM after the clamp fires. If the 13-vs-24 split recurs,
        // capture the /cart/change.js response from this transaction.
        qtyInput.value = inventory;
        showCartCeilingNotice(inventory);
      }
      var c = parseInt(qtyInput.value, 10) || 0;
      if (plusBtn) plusBtn.disabled = (c >= inventory);
    });
    qtyInput.dataset.siwsClampWired = 'true';
  }

  function showCartCeilingNotice(maxQty) {
    var id = 'siws-cart-ceiling-msg';
    var el = document.getElementById(id);
    if (!el) {
      el = document.createElement('div');
      el.id = id;
      var target = document.querySelector('cart-items') || document.querySelector('.cart__items') || document.querySelector('main');
      if (target && target.parentNode) target.parentNode.insertBefore(el, target);
    }
    el.innerHTML =
      '<div style="background:#fffbeb;border:1px solid #f59e0b;border-radius:8px;padding:12px 16px;font-size:0.875em;margin-bottom:12px;color:#92400e;">' +
      '⚠️ <strong>Only ' + maxQty + ' Available</strong> — quantity adjusted to the inventory ceiling.' +
      '</div>';
    clearTimeout(el._siwsClampTimer);
    el._siwsClampTimer = setTimeout(function () { if (el) el.innerHTML = ''; }, 5000);
  }

  window.SiwsInventoryClamp = {
    bindPdp: bindPdp,
    bindCartRow: bindCartRow,
  };
})();
